/**
 * Counts moments into `binCount` equal bins over `[fromMs, toMs]`, oldest bin first. A moment
 * outside the range goes to the bin at that edge, and a range of no length puts every moment in
 * the last bin.
 */
export function countIntoBins(
    timesMs: number[], fromMs: number, toMs: number, binCount: number,
): number[] {
    const bins = new Array<number>(binCount).fill(0);
    const binMs = (toMs - fromMs) / binCount;
    for (const timeMs of timesMs) {
        const index = binMs > 0 ? Math.floor((timeMs - fromMs) / binMs) : binCount - 1;
        const clampedIndex = Math.min(binCount - 1, Math.max(0, index));
        bins[clampedIndex] = (bins[clampedIndex] ?? 0) + 1;
    }
    return bins;
}
